import { render } from "./SubCategoryGoalCard.vue?vue&type=template&id=34f338ce&scoped=true"
import script from "./SubCategoryGoalCard.vue?vue&type=script&lang=js"
export * from "./SubCategoryGoalCard.vue?vue&type=script&lang=js"

import "./SubCategoryGoalCard.vue?vue&type=style&index=0&id=34f338ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34f338ce"]])

export default __exports__